"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _IconButton = _interopRequireDefault(require("./IconButton"));
var _Tooltip = _interopRequireDefault(require("../Tooltips/Tooltip"));
var _excluded = ["tooltipText", "disabled"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/** Define styles for icon */
var propTypes = {
  /** Name of the icon */
  name: _propTypes["default"].string,
  /** Text for the tooltip */
  tooltipText: _propTypes["default"].string,
  /** The color for the button. You can pass this and all other color props to the button*/
  color: _propTypes["default"].string,
  /** Specify a different color applied when hovering the button */
  hoverColor: _propTypes["default"].string,
  /** Disabled: will disable the button + change the cursor and hide the tooltip */
  disabled: _propTypes["default"].bool
};
var DeleteIconButton = function DeleteIconButton(_ref) {
  var _ref$tooltipText = _ref.tooltipText,
    tooltipText = _ref$tooltipText === void 0 ? "Delete" : _ref$tooltipText,
    disabled = _ref.disabled,
    buttonProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    tooltipText: tooltipText,
    disabled: disabled,
    triggerW: "auto"
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], _extends({
    shape: "round",
    w: "16px",
    iconSize: "xs",
    color: "textSecondary",
    hoverColor: "error",
    name: "CancelClear",
    disabled: disabled
  }, buttonProps)));
};
DeleteIconButton.propTypes = propTypes;
var _default = DeleteIconButton;
exports["default"] = _default;